import styled from 'styled-components';
import { realTimeFadeIn, realTimeFadeOut } from '../utils/Keyframes';
/**
 * Common properties for a pop-up with the dimensions of a tease notification
 * as well as support for fading in and out animations.
 */
const StyledTeaseBase = styled.div.withConfig({
  displayName: "StyledTeaseBase",
  componentId: "sc-18n15cb-0"
})(["max-width:24.25rem;width:24.25rem;animation:", " 500ms ease-in forwards;&:not(:first-child){margin-top:12px;}"], props => props.isOpen ? realTimeFadeIn : realTimeFadeOut);
export default StyledTeaseBase;